import React from 'react'
import { useLocation, useOutletContext } from 'react-router'
import { useNavigate } from 'react-router';
import { redirectToPayment } from '../services/redirect-to-payment';
import { OTP_DEFAULT } from '../constants/constants';
import { createEnterprise, createIndividual } from '../services/customer-creation-service';
import { sendOTP, verifyOTP } from '../services/otp-service';
import { OTP } from '../types/otp-input';

const EmailVerification = () => {
    const location = useLocation()
    const data = location.state
    const navigate = useNavigate()

    const [loading, setLoading] = useOutletContext<any>()
    const [otp, setOtp] = React.useState<OTP>(OTP_DEFAULT)
    const [error, setError] = React.useState('')
    const otpInputRefs = React.useRef<(HTMLInputElement | null)[]>([])

    React.useEffect(() => {
        if (!data) {
            navigate('/')
        }
    }, [])

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setOtp((prev) => ({ ...prev, [event.target.name]: event.target.value }))
    }

    const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>, index: number) => {
        const input = event.target as HTMLInputElement
        if (event.key === 'Backspace' && index > 0 && input.value === '') {
            otpInputRefs.current[index - 1]?.focus();
        }
    }

    const handleKeyUp = (event: React.KeyboardEvent<HTMLInputElement>, index: number) => {
        const input = event.target as HTMLInputElement
        if (event.key !== 'Backspace' && input.value !== '' && index < 5) {
            otpInputRefs.current[index + 1]?.focus();
        }
    }

    const otpInput = Object.keys(otp).map((element, index) => {
        return (
            <input type='text' autoComplete='off' key={index} name={`box${index + 1}`} ref={(ref: HTMLInputElement | null): void => { otpInputRefs.current[index] = ref }} value={otp[`box${index + 1}` as keyof OTP]} onChange={(event) => handleChange(event)} className='h-12 w-12 font-medium border rounded-lg border-white bg-[#CBD6E2] text-center outline-none' onKeyDown={(event) => handleKeyDown(event, index)} onKeyUp={(event) => handleKeyUp(event, index)} maxLength={1}></input>
        )
    })

    const proceed = async () => {
        const otpCode = Object.values(otp).join('')
        try {
            setLoading(true)
            setError('')
            const otpVerification = await verifyOTP(data.email, otpCode)
            if (otpVerification.status === 'success') {
                if (data.account_type === 'individual') {
                    const response = await createIndividual(data)
                    if (response.status !== 'success') {
                        setError(response.message)
                    } else {
                        navigate('/status', { state: { ...response, account_type: data.account_type } })
                    }
                }
                else if (data.account_type === 'small-business') {
                    const redirectionStatus = await redirectToPayment(data)
                    if (redirectionStatus?.status === false) {
                        setError(redirectionStatus.message)
                    }
                }
                else {
                    const response = await createEnterprise(data)
                    if (response.status !== 'success') {
                        setError(response.message)
                    } else {
                        navigate('/status', { state: { ...response, account_type: data.account_type } })
                    }
                }
            }
            else {
                setError(otpVerification.message)
            }
            setLoading(false)
        } catch (error) {
            setLoading(false)
            console.log(error, 'error')
            setError('Something Went Wrong')
        }
    }

    const resendOTP = async () => {
        try {
            setLoading(true)
            setError('')
            await sendOTP(data.email)
            setOtp(OTP_DEFAULT)
            setLoading(false)
        } catch (error) {
            setLoading(false)
            console.log(error)
        }
    }

    return (
        <div className='flex items-center justify-center bg-[#EFF4FF] min-h-[100vh]'>
            <div className='bg-white w-4/5  max-[768px]:w-11/12 py-10 flex my-16 flex-col items-center gap-10 rounded-lg font-poppins text-center'>
                <p className='font-medium text-3xl'>Please verify your email</p>
                <p className='font-normal text-xl'>You are almost there! We sent an OTP to {data && `${data.email}`}</p>
                <div className='flex flex-col items-center gap-4'>
                    <p className='font-medium text-xl'>Just confirm the 6 digit OTP below</p>
                    <div className='flex w-full items-center justify-center gap-3'>
                        {otpInput}
                    </div>
                    {error && <p className='text-red-500 w-4/5'>{error}</p>}
                    <p className='text-[#676767] text-xl font-normal'>If you don't see it, you may need to check your spam folder</p>
                </div>
                <div className='flex flex-col items-center'>
                    <p className='text-[#676767] text-xl font-normal'>Still can't find the email? <span className='text-[#1D58E2] cursor-pointer' onClick={() => resendOTP()}>Resend OTP</span></p>
                    <p className='text-[#676767] text-xl font-normal'>Need help? <span className='text-[#1D58E2] cursor-pointer'>Contact us</span></p>
                </div>
                <button type="submit" onClick={() => proceed()} className="py-3 bg-[#1D58E2] w-4/12 text-white mx-auto font-inter font-medium text-lg hover:bg-[#D2232A]">{data?.account_type === 'small-business' ? 'Confirm and Pay' : 'Confirm and Proceed'}</button>
            </div>
        </div>
    )
}

export default EmailVerification